export default __webpack_public_path__ + "static/media/final.8166fd20.wav";